/** Secure launch (M29): mirror of backend `app/core/constants/launch.py`.
 *  `backend/tests/core/test_m29_constants_mirror.py` keeps the two equal (a drift either way fails). */

export const SECURE_LAUNCH_FLAG = "secure_launch" as const;

/** Console settings panel id (`/w/:ws/settings/secure-launch`); registered by the Secure launch page work package. */
export const SECURE_LAUNCH_PANEL = "secure-launch" as const;

export const LAUNCH_CODE_PREFIX = "lc_" as const;

export const LAUNCH_CODE_BYTES = 32 as const;

export const LAUNCH_CODE_LENGTH = 46 as const;

export const LAUNCH_CODE_PATTERN = "^lc_[A-Za-z0-9_-]{43}$" as const;

export const LAUNCH_HASH_LENGTH = 64 as const;

/** The code rides after `#` only: `<base>/launch#code=lc_…`. */
export const LAUNCH_URL_FRAGMENT_KEY = "code" as const;

export const LAUNCH_PATH = "/launch" as const;

export const LAUNCH_ID_PREFIX = "ls_" as const;

export const LAUNCH_ID_PATTERN = "^ls_[0-9a-f]{32}$" as const;

export const LAUNCH_TTL_DEFAULT_S = 60 as const;

export const LAUNCH_TTL_MIN_S = 10 as const;

export const LAUNCH_TTL_MAX_S = 120 as const;

export const LAUNCH_STATE_PATTERN = "^[A-Za-z0-9_-]{16,128}$" as const;

export const LAUNCH_STATE_BYTES = 32 as const;

export const LAUNCH_ENTRY_TOPIC_PATTERN = "^[a-z0-9_]{1,64}$" as const;

export const LAUNCH_PARENT_ORIGIN_MAX = 255 as const;

export const LAUNCH_URL_MAX = 2048 as const;

export const LAUNCH_IDEMPOTENCY_KEY_PATTERN = "^[A-Za-z0-9._:-]{1,128}$" as const;

export const LAUNCH_IDEMPOTENCY_TTL_S = 86400 as const;

export const LAUNCH_AS_OF_FUTURE_SKEW_S = 300 as const;

export const LAUNCH_MODE_VALUES = ["tab", "embed", "app"] as const;
export type LaunchMode = (typeof LAUNCH_MODE_VALUES)[number];

export const LAUNCH_DEFAULT_MODE = "tab" as const;

export const LAUNCH_SESSION_KIND = "launch" as const;

export const LAUNCH_ACCESS_MINUTES_DEFAULT = 60 as const;

export const LAUNCH_ACCESS_MINUTES_MIN = 5 as const;

export const LAUNCH_ACCESS_MINUTES_MAX = 60 as const;

export const LAUNCH_IDLE_MINUTES_DEFAULT = 30 as const;

export const LAUNCH_IDLE_MINUTES_MIN = 5 as const;

export const LAUNCH_IDLE_MINUTES_MAX = 60 as const;

export const LAUNCH_ABSOLUTE_HOURS_DEFAULT = 8 as const;

export const LAUNCH_ABSOLUTE_HOURS_MIN = 1 as const;

export const LAUNCH_ABSOLUTE_HOURS_MAX = 12 as const;

export const LAUNCH_IDLE_TOUCH_INTERVAL_S = 30 as const;

export const LAUNCH_REVOCATION_CACHE_TTL_S = 30 as const;

export const LAUNCH_SESSIONS_RETENTION_DAYS = 7 as const;

export const REVOKE_REASON_VALUES = ["sign_out", "self_excluded", "locked", "closed", "password_reset", "other", "code_reuse", "status_policy", "staff"] as const;
export type RevokeReason = (typeof REVOKE_REASON_VALUES)[number];

/** Reasons an operator may send to `POST /api/v1/customers/sessions/revoke`. */
export const API_REVOKE_REASONS = ["sign_out", "self_excluded", "locked", "closed", "password_reset", "other"] as const;

export const ARRIVAL_METHOD_VALUES = ["launch", "email_code", "open_link"] as const;
export type ArrivalMethod = (typeof ARRIVAL_METHOD_VALUES)[number];

export const STATUS_POLICY_ACTION_VALUES = ["none", "flag", "flag_and_revoke"] as const;
export type StatusPolicyAction = (typeof STATUS_POLICY_ACTION_VALUES)[number];

export const DEFAULT_STATUS_POLICY = { self_excluded: "flag_and_revoke", closed: "flag_and_revoke" } as const;

export const LAUNCH_FRAME_ORIGINS_MAX = 10 as const;

export const LAUNCH_RETURN_URLS_MAX = 10 as const;

export const LAUNCH_CUSTOMER_TIERS_MAX = 20 as const;

export const LAUNCH_URL_SCHEME = "https://" as const;

/** Which Secure launch a workspace has (DEC-151): none, Lite (no customer facts, capped) or Plus (Plus add-on or Institution). */
export const LAUNCH_TIER_VALUES = ["none", "lite", "plus"] as const;
export type LaunchTier = (typeof LAUNCH_TIER_VALUES)[number];

/** Lite counts its launches by calendar month in this time zone (the reset is the 1st at 00:00). */
export const LAUNCH_USAGE_TIMEZONE = "Asia/Manila" as const;

/** The mint-body fields that are customer facts: Lite refuses them (403 `secure_launch_plus_required`), Plus accepts them. */
export const LAUNCH_FACT_FIELDS = ["tier", "account_status", "attributes"] as const;
